var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-cover"},[_c('button',{staticClass:"px-8 py-2",on:{"click":_vm.back}},[_vm._v("Cancel")]),_c('button',{staticClass:"px-10 py-2",attrs:{"type":"submit"}},[_vm._v("Save")])])
}
var staticRenderFns = []

export { render, staticRenderFns }